"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var fontWeight = _a.fontWeight, italic = _a.italic, muted = _a.muted, textAlign = _a.textAlign, rtl = _a.rtl, textDecoration = _a.textDecoration, textTransform = _a.textTransform, width = _a.width, props = __rest(_a, ["fontWeight", "italic", "muted", "textAlign", "rtl", "textDecoration", "textTransform", "width"]);
    return react_1.default.createElement("span", __assign({ ref: ref }, props));
});
innerFunction.displayName = "innerFunction";
var Text = styled_components_1.default(innerFunction)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  line-height: 1.25rem;\n  font-size: 1rem;\n  font-family: ", ";\n  text-align: ", ";\n  width: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  line-height: 1.25rem;\n  font-size: 1rem;\n  font-family: ", ";\n  text-align: ", ";\n  width: ", ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  font-weight: ",
    ";\n"])), style_utils_1.getColor("gray", 900), style_utils_1.getFont("sansSerif"), function (props) { return style_utils_1.escapeCss(props.textAlign); }, function (props) { return style_utils_1.escapeCss(props.width); }, function (props) {
    return props.italic && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-style: italic;\n    "], ["\n      font-style: italic;\n    "])));
}, function (props) {
    return props.textTransform && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      text-transform: ", ";\n    "], ["\n      text-transform: ", ";\n    "])), style_utils_1.escapeCss(props.textTransform));
}, function (props) {
    return props.textDecoration && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      text-decoration: ", ";\n    "], ["\n      text-decoration: ", ";\n    "])), style_utils_1.escapeCss(props.textDecoration));
}, function (props) {
    return props.muted && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), style_utils_1.colorSelector(props, "gray", 300));
}, function (props) {
    switch (props.fontWeight) {
        case "regular":
            return 400;
        case "semibold":
            return 500;
        case "bold":
            return 700;
        default:
            return null;
    }
});
Text.defaultProps = {
    fontWeight: "regular"
};
exports.default = Text;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map